import { Button } from '@mui/material';
import { useEffect,useState } from 'react'
import { useListContext,useUnselectAll } from 'react-admin';
import { BIN_ICON, COMPLETE_PROPAY_ACTION, PENDING_ICON, TICK_ICON_FILLED } from '../../utils/Constants/ClassName';
import { PropayBulkActionModal } from './PropayBulkActionModal';
import { NUMBER } from '../../utils/Constants/MagicNumber';
import { useIdentityContext } from '../../components/identity';

const PropayActions = (props)=>{
const {bulkAction,setHideAction,setBulkAction,hideAction} = props;
const { selectedIds = [] }=useListContext();
const [showActionModal,setShowActionModal]=useState(false);
const unselectAll = useUnselectAll();
useEffect(()=>{
    if(selectedIds.length > NUMBER.ZERO){
        setHideAction(false);
    }
    if(!selectedIds.length && !hideAction){
        setBulkAction('');
    }

},[selectedIds])

    return (
        <>
        <div className='close-statement-toolbar'>
        <span>{selectedIds.length} ProPays Selected </span>
        <ActionButton bulkAction={bulkAction} setShowActionModal={setShowActionModal}/>
        </div>
        <PropayBulkActionModal isOpen={showActionModal}
        action={bulkAction} selectedIds={selectedIds} onClose={()=>setShowActionModal(false)} unselectAll={unselectAll} />
        </>
        )
}

export default  PropayActions;

const ActionButton = ({setShowActionModal, bulkAction}) => {
    const identity = useIdentityContext();
    switch(bulkAction){
        case 'Approve':{
            return <Button className={'bulk-approve-button'} onClick={()=>setShowActionModal(true)}>{TICK_ICON_FILLED()} {bulkAction}</Button>
        }
        case 'Pending':{
            return <Button className={'bulk-pending-button'} onClick={()=>setShowActionModal(true)}>{PENDING_ICON()} {(identity?.company?.is_started_status && bulkAction === 'Pending') ? `${bulkAction} or Start` : bulkAction}</Button>
        }
        case 'Complete':{
            return <Button className={'complete-button'} onClick={()=>setShowActionModal(true)}>{COMPLETE_PROPAY_ACTION()} {bulkAction}</Button>
        }
        default:{
            return <Button className={'delete-button'} onClick={()=>setShowActionModal(true)}>{BIN_ICON()} {bulkAction}</Button>
        }
    }
}
